/* Hält die Erreichbarkeits-Anzeigen aktuell. Serverseitig rendert
   snippets/pf-status.liquid bereits den richtigen Zustand; hier wird er gegen
   die konfigurierte Zeitzone nachgerechnet, damit von Shopify gecachte Seiten
   nicht mit einem alten Zustand stehen bleiben.

   Geschlossen zeigt die Zeile, wann wieder jemand da ist: „heute ab“ (vor
   Beginn), „morgen ab“ oder „am Montag ab“. Dieselbe Rechnung wie im Snippet. */
(function () {
  'use strict';

  if (window.pfStatusReady) return;
  window.pfStatusReady = true;

  var WEEKDAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function setText(el, value) {
    if (el && value && el.textContent !== value) el.textContent = value;
  }

  // Offene Wochentage, 0 = Sonntag bis 6 = Samstag. Ohne Angabe gilt Mo–Fr.
  function offeneTage(days) {
    if (days === 'daily') return [0, 1, 2, 3, 4, 5, 6];
    if (days === 'mon_sat') return [1, 2, 3, 4, 5, 6];
    return [1, 2, 3, 4, 5];
  }

  function wiederDa(el, tage, dow, nowHm, from) {
    var ab = ' ab ' + (el.getAttribute('data-from-label') || '') + ' Uhr';
    if (tage.indexOf(dow) > -1 && nowHm < from) return 'heute' + ab;
    for (var i = 1; i <= 7; i++) {
      var tag = (dow + i) % 7;
      if (tage.indexOf(tag) > -1) return i === 1 ? 'morgen' + ab : 'am ' + TAGE[tag] + ab;
    }
    return el.getAttribute('data-closed-time');
  }

  function evaluate(el) {
    var from = parseInt(el.getAttribute('data-from'), 10);
    var to = parseInt(el.getAttribute('data-to'), 10);
    if (isNaN(from) || isNaN(to)) return;

    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: el.getAttribute('data-tz') || 'Europe/Berlin',
        weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) { return; }

    var hour = parseInt(parts.hour, 10);
    if (hour === 24) hour = 0; // manche Engines liefern für Mitternacht 24
    var nowHm = hour * 100 + parseInt(parts.minute, 10);
    var dow = WEEKDAYS.indexOf(String(parts.weekday || '').slice(0, 3).toLowerCase());
    if (dow < 0) return;
    var tage = offeneTage(el.getAttribute('data-days'));

    var open = tage.indexOf(dow) > -1 && nowHm >= from && nowHm < to;

    el.classList.toggle('is-open', open);
    el.classList.toggle('is-closed', !open);
    setText(el.querySelector('[data-pf-status-state]'), el.getAttribute(open ? 'data-open-label' : 'data-closed-label'));
    setText(el.querySelector('[data-pf-status-time]'), open ? el.getAttribute('data-open-time') : wiederDa(el, tage, dow, nowHm, from));
  }

  function boot() {
    document.querySelectorAll('[data-pf-status]').forEach(evaluate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setInterval(boot, 30000);
  document.addEventListener('shopify:section:load', boot);
})();
